import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { isNil } from '@/helpers/helpers'
import { allowedParams, isValidFilterValue, storedParamsKeys } from '@/helpers/filters'
import { getCookie, setCookie } from '@/helpers/cookieHelper'

interface QueryParamsHandlerProps {
  ignore: {
    time?: boolean
  }
}

const useQueryParamsHandler = (props?: QueryParamsHandlerProps): void => {
  const router = useRouter()
  const checkTimeParam = !props?.ignore?.time

  useEffect(() => {
    const updateQueryParams = (): void => {
      const query = new URLSearchParams(router.asPath.split(/\?/)[1])
      let shouldUpdateQueryParams = false

      const updateStoredParam = (key: string, localStorageKey: string): void => {
        const storedValue = getCookie(localStorageKey)
        const queryValue = query.get(key) as string
        if (!isNil(queryValue) && queryValue != storedValue && isValidFilterValue(key, queryValue)) {
          setCookie(localStorageKey, queryValue)
        }
      }

      updateStoredParam('viewMode', storedParamsKeys.viewMode)
      updateStoredParam('sortBy', storedParamsKeys.sortBy)
      if (checkTimeParam) {
        updateStoredParam('time', storedParamsKeys.time)
      }

      if (router.asPath.includes('#')) {
        const hash = router.asPath.split(/\#/)[1]
        const newQuery = new URLSearchParams(hash)
        newQuery.forEach((_, key) => {
          if (
            allowedParams.includes(key) &&
            isValidFilterValue(key, newQuery.get(key) as string) &&
            query.get(key) !== newQuery.get(key)
          ) {
            shouldUpdateQueryParams = true
            query.set(key, newQuery.get(key) as string)
          }
        })
      }

      query.forEach((_, key) => {
        if (!allowedParams.includes(key) || !isValidFilterValue(key, query.get(key) as string)) {
          query.delete(key)
          shouldUpdateQueryParams = true
        }
      })

      if (shouldUpdateQueryParams) {
        const pathWithoutHash = router.asPath.split(/\#/)[0]
        const newPath = pathWithoutHash.split(/\?/)[0]
        const newUrl = `${newPath}?${query.toString()}`
        router.replace(newUrl, newUrl, { shallow: false })
      }
    }

    if (router.isReady) {
      updateQueryParams()
    }
  }, [router])
}

export default useQueryParamsHandler
